module.exports = __webpack_public_path__ + "static/venor-0b3a9b8e8f5c06fd9445f3999e94d09b.png";